import React, { useState } from 'react';
import { Panel } from '../../compat/PanelCompat';
import PropTypes from 'prop-types';

import DataComparisonTable from '../reusable/comparisonTables/DataComparisonTable';
import DataComparisonTableMobile from '../reusable/comparisonTables/DataComparisonTableMobile';
import IconComparisonTable from '../reusable/comparisonTables/IconComparisonTable';
import IconComparisonTableMobile from '../reusable/comparisonTables/IconComparisonTableMobile';
import usersIcon from '../../../../image/Icons/Table-Users.svg';

/**
 * BlockbriefComparisonTable.
 * Comparison table.
 *
 * @author  Manny
 * @param   {Object}      props.features        Product data.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {Boolean}     props.isMobile        Determines if tables are for mobile format.
 * @param   {String}      props.packageKey      Name of the package.
 * @returns {JSX.Element} The component markup.
 */

const BlockbriefComparisonTable = ({ features, industryPackage, isMobile = false, packageKey }) => {
  const [openPanels, setOpenPanels] = useState([true]);
  const { data, lga, users_geo } = features || {};

  const togglePanel = (index) => {
    let newOpen = [...openPanels];
    newOpen[index] = !newOpen[index];
    setOpenPanels(newOpen);
  };

  return (
    <div>
      <Panel defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle onClick={() => togglePanel(0)}>
            <div className='tab-header body-semibold'>
              <img className='panel-header-icon' src={usersIcon} alt='' />
              Users & Geography{' '}
              <span
                className={
                  openPanels[0]
                    ? 'panel-dropdown-icon carat-up'
                    : 'panel-dropdown-icon carat-down'
                }
                aria-hidden='true'
              ></span>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {isMobile ? (
              <>
                <DataComparisonTableMobile
                  industryPackage={industryPackage}
                  data={users_geo}
                  type='users_geo'
                  packageKey={packageKey}
                />
                <IconComparisonTableMobile
                  industryPackage={industryPackage}
                  data={data}
                  type='data'
                  packageKey={packageKey}
                />
                <DataComparisonTableMobile
                  industryPackage={industryPackage}
                  data={lga}
                  type='lga'
                  packageKey={packageKey}
                />
              </>
            ) : (
              <>
                <DataComparisonTable
                  industryPackage={industryPackage}
                  data={users_geo}
                  type='users_geo'
                />
                <IconComparisonTable industryPackage={industryPackage} data={data} type='data' />
                <DataComparisonTable industryPackage={industryPackage} data={lga} type='lga' />
              </>
            )}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    </div>
  );
};

BlockbriefComparisonTable.propTypes = {
  features: PropTypes.object.isRequired,
  industryPackage: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  packageKey: PropTypes.string
};

export default BlockbriefComparisonTable;
